<template>
  <div :class="{ 'menu-collapse': collapse, menu: true }">
    <el-menu class="el-menu-vertical-demo" :default-active="activeIndex" :collapse="collapse" :router="true">
      <el-menu-item v-for="item of menuList" :index="item.index" :key="item.index">
        <i class="iconfont" :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'asideMenu',
  data() {
    return {
      menuList: [
        {
          index: '/index',
          title: '主页',
          icon: 'iconshouye',
        },
        {
          index: '/trading',
          title: '交易中心',
          icon: 'iconzhifu',
        },
        {
          index: '/reconciliation',
          title: '财务对账',
          icon: 'iconduizhangxiangqing',
        },
        {
          index: '/statistics',
          title: '数据统计',
          icon: 'iconzu3100',
        },
        {
          index: '/account',
          title: '账户管理',
          icon: 'iconlujing1584',
        },
        {
          index: '/setup',
          title: '平台设置',
          icon: 'iconshezhi',
        },
        {
          index: '/merchants',
          title: '商户管理',
          icon: 'iconshezhi',
        },
      ],
    };
  },
  computed: {
    ...mapState('main', ['collapse']),
    activeIndex() {
      let index = this.menuList.find(item => this.$route.path.includes(item.index));
      index = index ? index.index : undefined;
      return index;
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.menu {
  background-color: @bg-white;
}
.menu-collapse {
  width: fit-content;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: @aside-width;
  min-height: 400px;
}

// 定义菜单用到的变量
@menu-item-height: 54px;
.is-active {
  color: @primary-blue;
  background-color: #f8f8f8;
  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    height: @menu-item-height;
    width: 3px;
    background-color: @primary-blue;
  }
  .iconfont {
    color: @primary-blue;
  }
}
// 重写菜单样式
.el-menu {
  border-right: 0;
}
.el-menu-item {
  position: relative;
  padding-left: 0 !important;
  box-sizing: border-box;
  height: @menu-item-height;
  color: @font-color-black;
  font-size: @aside-font-size;
  margin-top: 20px;
  .box_row_center();
  .iconfont {
    color: @font-color-black;
    margin-right: 0.5em;
    margin-left: 64px;
  }
  &:first-child {
    margin-top: 10px;
  }
}
.el-menu--collapse .el-menu-item .iconfont {
  margin-left: 0;
}
.el-menu-item.is-active {
  .is-active();
  font-weight: 700;
}
.el-menu-item:focus,
.el-menu-item:hover {
  .is-active();
}
</style>
